import { MapPageSkeleton } from '../pages/map/MapPageSkeleton';
import { LoadingSkeleton } from '../shared/ui/loading';
import type { AppRoute } from './routes';
import './route-loading.css';

function Heading() {
  return (
    <div className="route-loading-heading" aria-hidden="true">
      <span className="loading-block" />
      <span className="loading-block" />
    </div>
  );
}
function Tabs() {
  return (
    <div className="route-loading-tabs" aria-hidden="true">
      {Array.from({ length: 6 }, (_, i) => (
        <span className="loading-block" key={i} />
      ))}
    </div>
  );
}
export function RouteLoading({ route }: { route: AppRoute }) {
  if (route.area === 'ifc-viewer')
    return (
      <main className="ifc-viewer-startup" role="status">
        Đang mở trình xem IFC…
      </main>
    );
  if (route.area === 'map') return <MapPageSkeleton />;
  if (route.area === 'document-preview')
    return (
      <main>
        <LoadingSkeleton variant="document" label="Đang mở tài liệu…" />
      </main>
    );
  if (route.area === 'admin')
    return (
      <div className="admin-workspace route-loading-admin">
        <header className="admin-header" aria-hidden="true">
          <span className="loading-block" />
          <span className="loading-block" />
        </header>
        <aside className="admin-sidebar" aria-hidden="true">
          {[3, 4, 3].map((count, group) => (
            <div className="admin-nav-group" key={group}>
              <span className="loading-block admin-nav-skeleton-label" />
              <div className="admin-nav-skeleton-items">
                {Array.from({ length: count }, (_, i) => (
                  <span className="loading-block" key={i} />
                ))}
              </div>
            </div>
          ))}
        </aside>
        <main className="admin-main">
          <Heading />
          {route.section === 'overview' && <Tabs />}
          <LoadingSkeleton
            variant={
              route.section === 'overview'
                ? 'dashboard'
                : route.resource?.mode === 'detail' || route.resource?.mode === 'edit'
                  ? 'detail'
                  : 'table'
            }
            label="Đang mở trang quản trị…"
          />
        </main>
      </div>
    );
  if (route.area === 'dashboard')
    return (
      <main className="route-loading-dashboard">
        <div className="route-loading-dashboard-content">
          <header className="route-loading-public-header" aria-hidden="true">
            <strong>
              BIM–GIS<small>An Giang</small>
            </strong>
            <span className="loading-block" />
          </header>
          <Heading />
          <Tabs />
          <LoadingSkeleton
            variant={route.id ? 'detail' : route.kind ? 'table' : 'dashboard'}
            label="Đang tải tổng quan công trình…"
          />
        </div>
      </main>
    );
  return (
    <main>
      <LoadingSkeleton variant="page" label="Đang mở không gian làm việc…" />
    </main>
  );
}
